/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import Command from '@ckeditor/ckeditor5-core/src/command';
import { toMap } from '@ckeditor/ckeditor5-utils';

class AddReferenceCommand extends Command {
	refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;

        const parent = selection.anchor.parent;

        if (parent.name === "reference") {
            model.change( writer => {
                // Place the selection on the reference element
                writer.setSelection( parent, "on" );
            } );
        }

        const selectedElement = selection.getSelectedElement();
        if ( selectedElement && selectedElement.name === "reference" ) {
            model.change( writer => {
                // Remove duplicated attributes inserted in the reference element children
                for ( const child of selectedElement.getChildren() ) {
                    writer.clearAttributes( child );
                }
            } );
        }

        this.isEnabled = true;
    }

	execute( reference ) {
		const model = this.editor.model;
		const selection = model.document.selection;

        model.change( writer => {
            if (reference !== '') {
                // Get selection current attributes
                const attributes = toMap( selection.getAttributes() );

                // Add the text attribute to the map of attributes
                attributes.set( 'text', reference );

                const referenceElement = writer.createElement('reference',  attributes);
                const textNode = writer.createText(reference);
                writer.insert(textNode, referenceElement, 'end');
                const insertedElement = model.insertContent(referenceElement, selection);
                writer.setSelection(insertedElement, 'end');
            } else {
                // If selection is reference element and the user put nothing ("")
                // in the "referenceInputView" form field.
                // Else do nothing.
                const selectedElement = selection.getSelectedElement();
                if ( selectedElement && selectedElement.name === 'reference' ) {
                    writer.remove(selectedElement);
                }
            }
        } );
	}
}

class RemoveReferenceCommand extends Command {
    execute() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const lastPosition = selection.getLastPosition();

        model.change( writer => {
            // Remove <reference> tag. Before the removal, transfer the attributes from the
            // reference element to its children
            const referenceElement = selection.getSelectedElement();
            const attributes = toMap( referenceElement.getAttributes() )
            for ( const child of referenceElement.getChildren() ) {
                writer.setAttributes( attributes, child );
            }
            writer.unwrap(referenceElement);

            // Put the selection on the inserted element.
            writer.setSelection(lastPosition);
        } );
    }
}

export { AddReferenceCommand, RemoveReferenceCommand };
